package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.TwitchSimpleIcons: ImageVector
    get() {
        if (_twitchSimpleIcons != null) {
            return _twitchSimpleIcons!!
        }
        _twitchSimpleIcons = Builder(name = "TwitchSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(11.57f, 4.71f)
                horizontalLineToRelative(1.72f)
                verticalLineToRelative(5.14f)
                lineTo(11.57f, 9.86f)
                close()
                moveTo(16.29f, 4.71f)
                lineTo(18.0f, 4.71f)
                verticalLineToRelative(5.14f)
                horizontalLineToRelative(-1.71f)
                close()
                moveTo(6.0f, 0.0f)
                lineTo(1.71f, 4.29f)
                verticalLineToRelative(15.43f)
                horizontalLineToRelative(5.14f)
                lineTo(6.86f, 24.0f)
                lineToRelative(4.29f, -4.29f)
                horizontalLineToRelative(3.43f)
                lineTo(22.29f, 12.0f)
                lineTo(22.29f, 0.0f)
                close()
                moveTo(20.57f, 11.14f)
                lineToRelative(-3.43f, 3.43f)
                horizontalLineToRelative(-3.43f)
                lineToRelative(-3.0f, 3.0f)
                verticalLineToRelative(-3.0f)
                lineTo(6.86f, 14.57f)
                lineTo(6.86f, 1.71f)
                horizontalLineToRelative(13.71f)
                close()
            }
        }
        .build()
        return _twitchSimpleIcons!!
    }

private var _twitchSimpleIcons: ImageVector? = null
